import type { ConversionRateCardState } from "./ConversionRateCardShell";
import type { ConversionRateAvailability } from "./getConversionRateAvailability";

export const resolveCardState = (
    availability: Exclude<ConversionRateAvailability, "hidden">,
    isLoading: boolean,
): ConversionRateCardState => {
    if (availability === "locked") {
        return "locked";
    }
    if (isLoading) {
        return "loading";
    }
    return "available";
};
